import { PlusIcon } from '..';
import AGButton from '../../../components/Button';
import { RolesHandle } from '../../../components/RolesHandle';
import { BrochureProps } from './videoModal.props';
import { Div, VideoURLLink } from './videoModal.styled';

const VideoModal = ({ setShow, bodyContent, data, dataService, isService }: BrochureProps) => {
    var videoId = null;
    const maxLength = 50;
    if (data?.videoUrl) {
        videoId = getYoutubeEmbedLink(data!.videoUrl);
    }
    if (!data) {
        return null;
    }
    return (
        <>
            {videoId && isYouTubeVideo(data!.videoUrl!) ? (
                <Div className="description w-full">
                    <Div className="outerCon w-full">
                        <iframe className='video'
                            title='Youtube player'
                            src={videoId}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen={true}
                        >
                            
                        </iframe>
                    </Div>
                </Div>
            ) : (
                <VideoURLLink
                    className="video-url"
                    href={data?.videoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {data && data.videoUrl && data.videoUrl.length > maxLength
                        ? `${data.videoUrl.slice(0, maxLength)}...`
                        : data?.videoUrl}
                </VideoURLLink>
            )}
            {
                !data?.videoUrl &&
                <RolesHandle roles={["Admin", "FirmCommerceManagement"]}
                    firmId={data?.fkFirmId!}
                >
                    <Div className='btn-add-new'>
                        <AGButton
                            type={'Link'}
                            icon={<PlusIcon />}
                            onClick={() => {
                                setShow()
                            }}>
                            {bodyContent}
                        </AGButton>
                    </Div>
                </RolesHandle>
            }
        </>
    )
};

export function isEmbeddedLink(link: string) {
    return link.includes('youtube.com/embed/');
}
export function isYouTubeVideo(url: string) {
    const youtubePattern = url.toLocaleLowerCase().includes("youtube.com") || url.toLocaleLowerCase().includes("youtu.be");
    return youtubePattern;
}
export function getYoutubeEmbedLink(youtubeLink?: string) {
    if (!youtubeLink) { return null; }
    if (isEmbeddedLink(youtubeLink)) {
        return youtubeLink;
    }

    const regex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const match = youtubeLink.match(regex);

    if (match && match[1]) {
        const videoId = match[1];
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;
        return embedUrl;
    } else {
        return null;
    }
}
export default VideoModal;